import React, { useRef, useContext } from "react"
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog"
import { Toast } from "primereact/toast"
import { UserContext } from "../../../context/userContext"
import { useMutation } from "@apollo/client"
import { CHANGE_STATUS_ENTERPRISE, GET_ENTERPRISES } from "../queries"
import { InputSwitch } from "primereact/inputswitch"

export default function StatusChangeDialog(props) {
  const toast = useRef(null)
  const userCtx = useContext(UserContext)
  const [changeStatusEnterprise] = useMutation(CHANGE_STATUS_ENTERPRISE)

  const handleOnChange = (value, enterprise_id) => {
    changeStatusEnterprise({
      variables: {
        staff_id: userCtx?.session.user.staff_id,
        enterprise_id: enterprise_id,
        enterprise_status: value,
      },
      skip: !userCtx.session.user.staff_id,
      refetchQueries: [
        {
          query: GET_ENTERPRISES,
          variables: {
            staff_id: userCtx?.session.user.staff_id,
            enterprise_id: userCtx?.enterprise_id,
          },
        },
      ],
      fetchPolicy: "no-cache",
    }).then(async () => {
      //Check if the current enterprise is being deactivated and change the selection if it is.
      if (
        userCtx.session.user.enterprise_id === enterprise_id &&
        value === "INACTIVE"
      ) {
        const enterpriseDocs = userCtx.session.enterprise_list
        const otherEnterpriseDocs = enterpriseDocs.filter(
          (docRef) => docRef.id !== enterprise_id
        )

        if (otherEnterpriseDocs.length > 0) {
          for (const docRef of otherEnterpriseDocs) {
            const doc = await docRef.get()
            if (doc.exists && doc.data().enterprise_status === "ACTIVE") {
              userCtx.changeEnterprise(doc.id)
              return // Switched successfully, so we can exit.
            }
          }
        }
      }

      // Refresh data if not switching, or if no other active enterprise was found.
      userCtx.refreshData()
    })
  }

  const accept = () => {
    const newStatus =
      props.data.enterprise_status === "ACTIVE" ? "INACTIVE" : "ACTIVE"
    handleOnChange(newStatus, props.data.enterprise_id)

    let message = ""
    let title = ""
    switch (newStatus) {
      case "ACTIVE":
        title = "Enterprise activated"
        message = props.data.enterprise_name + " has been activated"
        break
      case "INACTIVE":
        title = "Enterprise inactivated"
        message = props.data.enterprise_name + " has been inactivated"
        break

      default:
        break
    }

    toast.current.show({
      severity: "info",
      summary: title,
      detail: message,
      life: 3000,
    })
  }

  const reject = () => {
    toast.current.show({
      severity: "warn",
      summary: "Rejected",
      detail: "You have rejected",
      life: 3000,
    })
  }

  const confirmChange = () => {
    if (props.data.enterprise_status === "ACTIVE") {
      confirmDialog({
        message:
          "Making the Enterprise Inactive will close ALL staff user sessions and close access to RecoveryLink for all organizations within the enterprise.",
        header: "Confirmation of Inactivation",
        icon: "pi pi-info-circle",
        defaultFocus: "reject",
        acceptClassName: "p-button-danger",
        accept,
        reject,
      })
    } else {
      confirmDialog({
        message:
          "Proceed to activate the Enterprise? This will allow staff users to access RecoveryLink.",
        header: "Confirmation",
        icon: "pi pi-exclamation-triangle",
        defaultFocus: "accept",
        accept,
        reject,
      })
    }
  }

  return (
    <>
      <Toast ref={toast} />
      <ConfirmDialog />
      <div>
        <InputSwitch
          checked={props.data.enterprise_status === "ACTIVE"}
          onChange={confirmChange}
        />
      </div>
    </>
  )
}
